// KR DDAT-698 포트 (DDAT-1660). in-flight 싱글톤으로 refresh 동시 호출을 1회로 dedup —
// RT 회전 경합(old RT 재사용 → E0803 강제 로그아웃)을 차단한다.
import axios from 'axios';

let inFlight = null;

export function callRefreshTokenSingleton(authUrl) {
	if (inFlight) return inFlight;

	const promise = axios.get(`${authUrl}/api/auth/refreshToken`);

	inFlight = promise.finally(() => {
		inFlight = null;
	});
	return inFlight;
}

export function __resetRefreshTokenSingleton() {
	inFlight = null;
}
